import React from 'react';
import { store, history } from "./store/store";
import Root from './components/Root';
import axios from 'axios';
import * as serviceWorker from './serviceWorker';
import { getAuthToken, setAuthToken } from './services/auth';
import Cookies from 'universal-cookie';
import { createRoot } from 'react-dom/client';


const query = new URLSearchParams(window.location.search);
const token = query.get('token')


console.log("index - ");


let showContent = true;
if (token) {
  console.log("index - token found");

  setAuthToken(token);

  const cookies = new Cookies();
  //window.location.href = cookies.get('mySavedUrl');

  if (cookies.get('mySavedUrl')) {
    console.log("index - cookie found: ", cookies.get('mySavedUrl'));
    window.location = cookies.get('mySavedUrl');
  }
  else {
    console.log("index - no saved url / cookie found");
    showContent = false;
    window.location = "/"
  }
}

else{
  console.log("index - no token found, show content",showContent);
}

if (showContent) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + getAuthToken();
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<Root store={store} history={history} />);
  if (module.hot) {
    module.hot.accept('./components/Root', () => {
      const NewRoot = require('./components/Root').default;
      root.render(<NewRoot store={store} history={history} />);
    });
  }


  serviceWorker.unregister();
}
else {
  console.log("index - do not show content / redirect failed");
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<div className="m-4 text-center">Token found, but no cookie, redirect failed</div>);
}
